<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>
<app-navside-sponsor></app-navside-sponsor>

<div class="container pt-5">
  <div class="d-flex flex-row bd-highlight">
    <div class="col-lg-6 col-md-8 p-2 mx-xl-auto mx-lg-auto ml-md-auto content-main">
      <div class="card my-3"  *ngFor="let storeproductDoc of storeproductCol | async">
        <div class="list-group my-1">
          <a class="list-group-item list-group-flush border-0">                
            <div class="media">                        
              <img [src]="storeproductDoc.ownerProfilePictureUrl" class="mr-3 align-self-center rounded-circle image" alt="...">
              <div class="media-body">
                <h3>{{storeproductDoc.ownerName}}</h3>
                <h5>{{storeproductDoc.ownerPhone}}</h5>
              </div>
            </div>               
          </a>   
        </div>           
        <img [src]="storeproductDoc.pictureUrl" class="card-img-top" style="height: 24rem;" alt="...">
        <div class="card-body">
            <p class="font-weight-bold text-right text-muted">{{storeproductDoc.dateCreated | date}}</p>
            <h3 class="card-title">{{storeproductDoc.name}}</h3>
            <p>{{storeproductDoc.price | currency:'K'}}</p>
            <p>{{storeproductDoc.ownerLocation}}</p>                       
            <p class="card-text">{{storeproductDoc.description}}</p>
            <a (click)="routeStoreProductDetailPage(storeproductDoc.id)" routerLink="" class="btn btn-dark text-white stretched-link">View Details...</a>
        </div>
      </div>
    </div>
  </div>
</div>
